
import { ArrayHelper } from "../../../dev/utils/ArrayHelper";
import { SoundManager } from "../../config/sound/SoundManager";

import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { RoadRageEngineController } from "../../reel/RoadRageEngineController";
import { GameData } from "../../server/data/BaseModel";
import { StopPresentation } from "../general/StopPresentation";
import { SoundConfig } from '../../config/sound/SoundConfig';
import { RoadRage } from '../../RoadRage';
import { RoadRageReelOverlay } from '../../reel/RoadRageReelOverlay';

export class RespinStopPresentation extends StopPresentation {

    stopOrder: number[];
    attentionReels: boolean[];

    respinStopCounter = 0;


    setGamedData(data: GameData): void {
        super.setGamedData(data);
        this.attentionReels = data.Reel.reelsWithScatters;
        this.stopOrder = [];

        this.respinStopCounter = 0;
        for (let r: number = 0; r < 2; r++) {
            for (let i = 0; i < this.attentionReels.length; i++) {
                if (!r && !this.attentionReels[i] || (r && this.attentionReels[i])) this.stopOrder.push(i);
            }
        }
    }

    preStart(): void {
        this.attCount = 0;
        super.preStart();
        SoundManager.fadeOutAmbient(500, 0.3);

        SoundManager.playRespinSound();

        RoadRageEngineManager.RAll(r => { if(this.attentionReels[r.reelID]) r.attention(true); })

        RoadRageReelOverlay.instance.playLightning(true);
    }

    createStopSpins(): void {
        RoadRageEngineManager.RAll((rc: RoadRageEngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }, this.gameData.raw.scatterReels[rc.reelID]));
    }

    createPresentation(enableSkip: Function) {
        enableSkip(!RoadRageEngineManager.isQuickStop);
    

        if (this.readyToDefineStop()) {

            this.createStopSpins();

            const delay: number[] = this.defineDelays();

            RoadRageEngineManager.stopReels(delay, this.stopOrder);
        }
    }

    defineDelays(): number[] {

        const delay: number[] = ArrayHelper.initArrayWithValues(RoadRageEngineManager.AllReels.length, () => 0)

        let attentionDelay: number = 1;
        for (let i: number = 0; i < this.attentionReels.length; i++) {
            if (this.attentionReels[i]) {
                delay[i] = attentionDelay;
                attentionDelay++;
            }
        }

        return delay;
    }

    onStops(rc: RoadRageEngineController): void {
        if(!this.attentionReels[rc.reelID]){
            rc.setGraphAlpha(0.7, rc.stopDuration);
        }
        else{
            rc.setGraphAlpha(0.4, rc.stopDuration);
        }
    }

    private attCount:number = 0;
    onBounce(rc: RoadRageEngineController): void {

        if(this.attentionReels[rc.reelID]){
            if(this.attCount){
                RoadRageReelOverlay.instance.playLightning(false);
            }
            this.attCount++;
        }

        if (this.gameData.Reel.YellowCarPositions[rc.reelID].length) {
            const startPos: number = this.animationTl.time();

            let upgrades:boolean = false;

            rc.AllWindowSymbols.forEach(s => {
                if (!s.isCar) {
                    this.animationTl.add(s.addMult(1, undefined, true), startPos);
                    this.animationTl.add(() => { s.Explosion() }, startPos);
                    this.animationTl.to(this,{duration:0.05})
                }
            });

            this.animationTl.add(() => {
                if(upgrades){
                    SoundManager.playSoundEffect(SoundConfig.MULT_LAND_UPGRADE)
                }else{
                    SoundManager.playSoundEffect(SoundConfig.MULT_LAND)
                }
            },startPos+0.8)
        }

       
        rc.attention(false);

        // this.flashCarDirection(rc);
        this.playBounceSound(rc.reelID);

        if(this.attentionReels[rc.reelID]){
            if(this.respinStopCounter) SoundManager.stopRespinSound();
            this.respinStopCounter++;
        }

        rc.AllWindowSymbols.forEach(s => {
             s.onBounceEffect(rc.engine.timeLeft);
        });

        // this.possibleWinNonWins(rc.reelID);
    }

    onStopped(rc: RoadRageEngineController) {
       
    }

    onScatterLanding(rc: RoadRageEngineController) {
    }

    done(): void {
        RoadRage.backgroundElements.slowDownCloud();
        SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        RoadRageEngineManager.RAll(r => { r.attention(false); r.setGraphAlpha(0, 0.4) });
        SoundManager.fadeInAmbient(6000);
    }
}